import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Hidden from '@material-ui/core/Hidden'

import viewTileOn from '../images/svg/view-tile-on.svg'
import viewTileOff from '../images/svg/view-tile-off.svg'
import viewListOn from '../images/svg/view-list-on.svg'
import viewListOff from '../images/svg/view-list-off.svg'

const styles = theme => ({
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  button: {
    borderRadius: '0',
  },
  viewTileOn: {
    width: '50px',
    height: '30px',
    borderRadius: '4px 0 0 4px',
    border: 'solid 1px #00bcb5',
    backgroundColor: '#ffffff',
  },
  viewListOn: {
    width: '50px',
    height: '30px',
    borderRadius: '0 4px 4px 0',
    border: 'solid 1px #00bcb5',
    backgroundColor: '#ffffff',
  },
  bgOn: {
    backgroundColor: '#00bcb5',
  },

  gridAuto: {
    flex: 'none',
    marginLeft: '10px',
  },
})

class ViewToggle extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  render() {
    const { classes, isGridView, handler } = this.props

    return (
      <Hidden mdDown>
        <Grid className={classes.gridAuto} item xs={4} align="right">
          <Button
            className={classes.button}
            style={{
              padding: 0,
              minWidth: 'auto',
              minHeight: 0,
            }}
            title="Grid View"
            onClick={() => handler(true)}>
            <img src={isGridView ? viewTileOn : viewTileOff} alt={'Tile'} className={`${classes.viewTileOn} ${isGridView ? classes.bgOn : null}`} />
          </Button>
          <Button
            className={classes.button}
            style={{
              padding: 0,
              minWidth: 'auto',
              minHeight: 0,
            }}
            title="List View"
            onClick={() => handler(false)}>
            <img src={isGridView ? viewListOff : viewListOn} alt={'List'} className={`${classes.viewListOn} ${isGridView ? null : classes.bgOn}`} />
          </Button>
        </Grid>
      </Hidden>
    )
  }
}

export default withStyles(styles)(ViewToggle)



// WEBPACK FOOTER //
// ./src/components/ViewToggle.js